import { DateTime } from "luxon";
import React from "react";

const EpStartV2 = ({ sessionData }) => {
  const { ep, inscriptions, startEp, isStarting } = sessionData;

  const nbInscriptions = inscriptions?.length || 0;
  const dateFormatted = DateTime.fromISO(ep.beginAt)
    .setLocale("fr")
    .toFormat("EEEE dd MMMM yyyy");
  const timeFormatted = DateTime.fromISO(ep.beginAt)
    .setLocale("fr")
    .toFormat("HH'h'mm");

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center animated fadeInUp faster"
      style={{ minHeight: "60vh", padding: "40px 20px" }}
    >
      <div style={{ maxWidth: 560, width: "100%" }}>
        {/* Icon */}
        <div className="text-center mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center"
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
              boxShadow: "0 8px 24px rgba(37,99,235,0.25)",
            }}
          >
            <i
              className="fa fa-users"
              style={{ fontSize: 32, color: "#fff" }}
            />
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-4">
          <h2
            style={{
              fontSize: 26,
              fontWeight: 800,
              color: "#1e293b",
              letterSpacing: -0.5,
              marginBottom: 6,
            }}
          >
            Session Équipe Pluridisciplinaire
          </h2>
          <p style={{ fontSize: 14, color: "#94a3b8", marginBottom: 0 }}>
            Prêt à démarrer la session ? Vérifiez les informations ci-dessous.
          </p>
        </div>

        {/* Info card */}
        <div
          className="rounded mb-4"
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          {/* Date header */}
          <div
            className="px-4 py-3"
            style={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
              color: "#fff",
            }}
          >
            <div className="d-flex align-items-center" style={{ gap: 12 }}>
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 10,
                  background: "rgba(255,255,255,0.15)",
                }}
              >
                <i className="fa fa-calendar" style={{ fontSize: 20 }} />
              </div>
              <div>
                <div
                  style={{
                    fontSize: 17,
                    fontWeight: 700,
                    textTransform: "capitalize",
                  }}
                >
                  {dateFormatted}
                </div>
                <div style={{ fontSize: 13, opacity: 0.85 }}>
                  Début prévu à {timeFormatted}
                </div>
              </div>
            </div>
          </div>

          {/* Details */}
          <div className="px-4 py-3">
            <div className="row">
              <div className="col-6 mb-3">
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#94a3b8",
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Secteur
                </div>
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#1e293b",
                    marginTop: 4,
                  }}
                >
                  {ep.sector?.name || ep.sector || "Non défini"}
                </div>
              </div>
              <div className="col-6 mb-3">
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#94a3b8",
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Allocataires inscrits
                </div>
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    color: "#1e293b",
                    marginTop: 4,
                  }}
                >
                  {nbInscriptions} allocataire{nbInscriptions > 1 ? "s" : ""}
                </div>
              </div>
              {ep.jury && (
                <div className="col-6">
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#94a3b8",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Membres du jury
                  </div>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: "#1e293b",
                      marginTop: 4,
                    }}
                  >
                    {ep.jury.length || 0} membre
                    {(ep.jury.length || 0) > 1 ? "s" : ""}
                  </div>
                </div>
              )}
              {ep.writer && (
                <div className="col-6">
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#94a3b8",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}
                  >
                    Secrétaire de séance
                  </div>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 600,
                      color: "#1e293b",
                      marginTop: 4,
                    }}
                  >
                    {ep.writerName || "Vous"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            className="btn btn-lg"
            onClick={startEp}
            disabled={isStarting}
            style={{
              background: isStarting
                ? "#e2e8f0"
                : "linear-gradient(135deg, #22c55e, #16a34a)",
              color: isStarting ? "#94a3b8" : "#fff",
              border: "none",
              padding: "14px 48px",
              fontSize: 17,
              fontWeight: 700,
              letterSpacing: 0.3,
              borderRadius: 12,
              boxShadow: isStarting ? "none" : "0 6px 20px rgba(34,197,94,0.3)",
              transition: "all 0.3s ease",
              width: "100%",
              maxWidth: 360,
            }}
          >
            {isStarting ? (
              <i className="fa fa-spinner fa-spin mr-2" />
            ) : (
              <i className="fa fa-play mr-2" />
            )}
            {isStarting ? "Démarrage en cours..." : "DÉMARRER LA SESSION"}
          </button>
          <div className="mt-3" style={{ fontSize: 12, color: "#94a3b8" }}>
            Le démarrage de la session vous désignera comme secrétaire de séance
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpStartV2;
